import React from 'react';
import {Input, DatePicker} from '../../form'
import {FormTemplateHeader, FormTemplateField, FormTemplateSectionWrapper} from '../../others/'

import Address from './Address'
import Insurance from './Insurance'
import { GENDER, RELATION_TO_INSURED } from '../../Constants';

const PrimaryInsuranceTab = (props)=> {
  const { insurance, template, isTemplate, isLongForm, patientRelationship, primaryInsurerSelectedCountry, primaryInsurerRegions, visionInsurancePlans, visionSecondaryInsurancePlans, visionTertiaryInsurancePlans, medicalInsurancePlans, secondaryInsurancePlans, tertiaryInsurancePlans, copyToInsurerAddress, selectedVisionInsuranceId, selectedMedicalInsuranceId, selectedSecondaryInsuranceId, selectedTertiaryInsuranceId, selectedVisionTertiaryInsuranceId, selectedVisionSecondaryInsuranceId, selectedVisionInsurance, selectedVisionSecondaryInsurance, selectedVisionTertiaryInsurance, selectedMedicalInsurance, selectedSecondaryInsurance, selectedTertiaryInsurance, formName } = props

  return(
    <div>
      {template && template.personal_information &&
        <div>
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.insurance_detail}>
            <div className={`row mx-0 mt-7 bg-white ${patientRelationship !=='self' ? 'shadow-sm' : 'mb-7'}`}>
              <div className="col-12 px-5">
                <FormTemplateHeader
                  isTemplate={isTemplate}
                  fieldValues={template.personal_information.insurance_detail}
                  baseName="personal_information[insurance_detail]"/>
              </div>
              <div className="col-12 px-7 pt-5">
                <div className="row">
                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_vision_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][vision_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.vision_insurance.fields}
                    insurancePlans={visionInsurancePlans}
                    selectedInsuranceId = { selectedVisionInsuranceId }
                    insuranceType="vision"
                    selectedInsurance={selectedVisionInsurance}
                  />

                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_vision_secondary_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][vision_secondary_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.vision_secondary_insurance.fields}
                    insurancePlans={visionSecondaryInsurancePlans}
                    selectedInsuranceId={selectedVisionSecondaryInsuranceId}
                    selectedInsurance={selectedVisionSecondaryInsurance}
                    insuranceType="vision"
                  />

                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_vision_tertiary_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][vision_tertiary_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.vision_tertiary_insurance.fields}
                    insurancePlans={visionTertiaryInsurancePlans}
                    selectedInsuranceId={selectedVisionTertiaryInsuranceId}
                    selectedInsurance={selectedVisionTertiaryInsurance}
                    insuranceType="vision"
                  />

                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_medical_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][medical_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.medical_insurance.fields}
                    insurancePlans={medicalInsurancePlans}
                    selectedInsuranceId = { selectedMedicalInsuranceId }
                    selectedInsurance={selectedMedicalInsurance}
                    insuranceType="medical"
                  />

                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_secondary_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][medical_secondary_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.medical_secondary_insurance.fields}
                    insurancePlans={secondaryInsurancePlans}
                    selectedInsuranceId = { selectedSecondaryInsuranceId }
                    selectedInsurance={selectedSecondaryInsurance}
                    insuranceType="medical"
                  />

                  <Insurance
                    formName={formName}
                    isTemplate={isTemplate}
                    basePatientName="patient_tertiary_insurance_attributes"
                    baseTemplateName="personal_information[insurance_detail][fields][medical_tertiary_insurance][fields]"
                    baseFieldValues={template.personal_information.insurance_detail.fields.medical_tertiary_insurance.fields}
                    insurancePlans={tertiaryInsurancePlans}
                    selectedInsuranceId = { selectedTertiaryInsuranceId }
                    selectedInsurance={selectedTertiaryInsurance}
                    insuranceType="medical"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="relation_to_insured"
                    baseName="personal_information[insurance_detail][fields][relation_to_insured]"
                    fieldValues={template.personal_information.insurance_detail.fields.relation_to_insured}
                    type="radioGroup"
                    wrapperClasses="col-6 mb-5"
                    onChangeHook={()=> copyToInsurerAddress(`home_address_attributes`, `primary_insurer`)}
                    options={RELATION_TO_INSURED}
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="feca_number"
                    baseName="personal_information[insurance_detail][fields][feca_number]"
                    fieldValues={{ ...template.personal_information.insurance_detail.fields.feca_number, required: selectedVisionInsuranceId && insurance.require_feca_number === true ? true : false }}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 mb-5"
                   />
                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
        { patientRelationship !=='self' &&
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.primary_insurer}>
            <div className="row mx-0 bg-white shadow-sm">
              <div className="col-12 px-5">
                <FormTemplateHeader
                  isTemplate={isTemplate}
                  fieldValues={template.personal_information.primary_insurer}
                  baseName="personal_information[primary_insurer]"/>
              </div>
              <div className="col-12 px-7 pt-5">
                <div className="row">
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_insurer[first_name]"
                    baseName="personal_information[primary_insurer][fields][first_name]"
                    fieldValues={template.personal_information.primary_insurer.fields.first_name}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_insurer[last_name]"
                    baseName="personal_information[primary_insurer][fields][last_name]"
                    fieldValues={template.personal_information.primary_insurer.fields.last_name}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_insurer[date_of_birth]"
                    baseName="personal_information[primary_insurer][fields][date_of_birth]"
                    fieldValues={template.personal_information.primary_insurer.fields.date_of_birth}
                    component={DatePicker}
                    dropUp={true}
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_insurer[member_id]"
                    baseName="personal_information[primary_insurer][fields][member_id]"
                    fieldValues={template.personal_information.primary_insurer.fields.member_id}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="primary_insurer[gender]"
                    baseName="personal_information[primary_insurer][fields][gender]"
                    fieldValues={template.personal_information.primary_insurer.fields.gender}
                    type="radioGroup"
                    wrapperClasses="col-6 mb-5"
                    options={GENDER}
                   />
                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
        }

        { isLongForm === true && patientRelationship !=='self' &&
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.primary_insurer_address}>
            <div className="row mx-0 bg-white shadow-sm">
              <div className="col-12 px-5">
                <FormTemplateHeader
                  isTemplate={isTemplate}
                  fieldValues={template.personal_information.primary_insurer_address}
                  baseName="personal_information[primary_insurer_address]"/>
              </div>
              <div className="col-12 px-7 pt-5">
                <div className="row">
                  <Address
                    isTemplate={isTemplate}
                    addressType="primary_insurer"
                    selectedCountry={primaryInsurerSelectedCountry}
                    regions={primaryInsurerRegions}
                    basePatientName="primary_insurer[address_attributes]"
                    baseTemplateName="personal_information[primary_insurer_address][fields]"
                    baseFieldValues={template.personal_information.primary_insurer_address.fields}/>
                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
        }
        </div>
      }
    </div>
  )
}

export default PrimaryInsuranceTab;
